import { currencyFormatterFactory } from './factory';
export function createCurrencyFormatterWithDefaults(defaults) {
    return function createCurrencyFormatter(params) {
        const overrides = {
            ...defaults,
            ...params,
        };
        return function format({ value, currency, }) {
            const instance = currencyFormatterFactory({ ...overrides, currency });
            const input = typeof value === 'string' ? Number(value) : value;
            if (overrides.parts) {
                return instance.formatToParts(input);
            }
            return instance.format(input);
        };
    };
}
//# sourceMappingURL=formatter.js.map